import { ConstructObservableContextBase } from './constructor';
import { OBSERVABLE_CONTEXT_BASE_PRIVATE } from './privates';
export function ObservableContextBaseGetObservable(instance) {
    return instance[OBSERVABLE_CONTEXT_BASE_PRIVATE].observable;
}
export class ObservableContextBase {
    constructor(observable) {
        ConstructObservableContextBase(this, observable);
    }
    get observable() {
        return ObservableContextBaseGetObservable(this);
    }
}
//# sourceMappingURL=implementation.js.map